import * as rateHelpers from "./rateHelpers";
import cn from "../../lib/classnames";
import React from "react";
import StarIcon from "./StarIcon";
import styles from "./Star.module.css";

type Props = {
    id: string;
    label: string;
    name: string;
    selectedValue: rateHelpers.Rating;
    setValue: (value: rateHelpers.Rating) => void;
    value: rateHelpers.Rating;
};

export default function Star(props: Props) {
    function onChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.currentTarget.value;
        if (rateHelpers.isRating(value)) {
            props.setValue(value);
        }
    }

    let colorStyle;
    if (props.selectedValue === rateHelpers.Rating.One) {
        colorStyle = styles.red;
    } else if (props.selectedValue === rateHelpers.Rating.Two) {
        colorStyle = styles.orange;
    } else if (props.selectedValue === rateHelpers.Rating.Three) {
        colorStyle = styles.yellow;
    } else if (props.selectedValue === rateHelpers.Rating.Four) {
        colorStyle = styles.lightGreen;
    } else if (props.selectedValue === rateHelpers.Rating.Five) {
        colorStyle = styles.green;
    }

    const valueNum = rateHelpers.getNumber(props.value);
    const selectedValueNum = rateHelpers.getNumber(props.selectedValue);

    return (
        <>
            <input
                checked={props.selectedValue === props.value}
                className={styles.starInput}
                id={props.id}
                name={props.name}
                onChange={onChange}
                type="radio"
                value={props.value}
            />
            <label
                aria-label={props.label}
                className={cn(
                    styles.starLabel,
                    valueNum <= selectedValueNum ? colorStyle : undefined,
                )}
                htmlFor={props.id}
            >
                <StarIcon className={styles.starIcon} />
            </label>
        </>
    );
}
